export function groupBy(array, funcProp) {
  return array.reduce(function(acc, val) {
    ;(acc[funcProp(val)] = acc[funcProp(val)] || []).push(val)
    return acc
  }, {})
}

/*
This solution takes any arbitrary function (not a key), and allows arrow functions,
which are similar to lambda expressions used in LINQ:

Example supported in most browsers:
[{a:1,b:"b"},{a:1,c:"c"},{a:2,d:"d"}].groupBy(function(c){return c.a;})

Example using arrow functions (ES6):
[{a:1,b:"b"},{a:1,c:"c"},{a:2,d:"d"}].groupBy(c=>c.a)

Both examples above return:

{
  "1": [{"a": 1, "b": "b"}, {"a": 1, "c": "c"}],
  "2": [{"a": 2, "d": "d"}]
}
 */
